<template>
    <el-dialog custom-class="validate_dialog" :model-value="show" width="422px" destroy-on-close :lock-scroll="false" @close="handleClose" @open="handleOpen">
        <div class="recipient_user_dialog_content">
            <div class="close" @click="handleClose">
                <Close class="icon" />
            </div>
            <div class="title_iocn"><i class="iconfont icon-_tianjiarenyuan"></i></div>
            <h1>{{ type === "add" ? "添加" : "修改" }}收件人</h1>
            <AnimationInput v-model="form.recipientName" maxlength="30" name="recipientName" placeholder="姓名" :autoFocus="true" />
            <br />
            <AnimationInput v-model="form.email" maxlength="60" name="recipientEmail" placeholder="邮箱" :autoFocus="false" />
            <br />
            <AnimationSelect v-model="form.groupId" name="groupId" placeholder="收件分组" :options="groupList" />
            <div class="checkbox">
                <el-checkbox v-model="form.emailWarning" label="接受预警邮件" />
            </div>
            <div class="btn_box" v-loading="loading">
                <button @click="submit">保存</button>
                <button @click="handleClose">取消</button>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import { reactive, ref, computed } from "vue";
import AnimationInput from "@/components/common/AnimationInput.vue";
import AnimationSelect from "@/components/common/AnimationSelect.vue";
import { Close } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import { apiRecipientAdd, apiRecipientUpdate } from "@/request/api";
import { isEmail } from "@/utils/validate";

const props = defineProps({
    show: { type: Boolean, default: false },
    type: { type: String, required: true },
    currentGroupId: { type: [String, Number], default: "" },
    row: { type: Object, default: {} },
    groupList: { type: Array, default: [] },
});
const emits = defineEmits(["close", "refresh"]);
const form = reactive({
    recipientName: "",
    email: "",
    groupId: "",
    emailWarning: true,
});
const loading = ref(false);
const formC = computed(() => {
    return {
        ...form,
        emailWarning: form.emailWarning ? "Y" : "N",
    };
});

async function submit() {
    if (!form.recipientName) {
        ElMessage.error("请输入姓名");
        return;
    }
    if (!form.email) {
        ElMessage.error("请输入邮箱");
        return;
    }
    if (!isEmail(form.email)) {
        ElMessage.error("请输入正确的邮箱");
        return;
    }
    if (!form.groupId) {
        ElMessage.error("请选择分组");
        return;
    }
    switch (props.type) {
        case "add":
            add();
            break;
        case "edit":
            edit();
            break;
    }
}

// 新增
async function add() {
    loading.value = true;
    try {
        const params = { ...formC.value };
        const { code } = await apiRecipientAdd(params);
        if (code !== "0") return;
        handleClose();
        emits("refresh");
    } finally {
        loading.value = false;
    }
}

// 编辑
async function edit() {
    loading.value = true;
    try {
        const params = { ...formC.value };
        params.recipientId = props.row.id;
        const { code } = await apiRecipientUpdate(params);
        if (code !== "0") return;
        handleClose();
        emits("refresh");
    } finally {
        loading.value = false;
    }
}

// 打开
function handleOpen() {
    if (props.type === "add") {
        form.groupId = props.currentGroupId || "";
        return;
    }
    form.recipientName = props.row?.recipientName || "";
    form.email = props.row?.email || "";
    form.groupId = props.row?.groupId || "";
    form.emailWarning = props.row?.emailWarning === "Y" ? true : false;
}

// 关闭
function handleClose() {
    form.recipientName = "";
    form.email = "";
    form.groupId = "";
    form.emailWarning = true;
    loading.value = false;
    emits("close");
}
</script>

<style lang="scss">
.validate_dialog {
    border-radius: 16px;
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
    }
    .recipient_user_dialog_content {
        padding: 34px;
        position: relative;
        text-align: center;
        .close {
            position: absolute;
            top: 32px;
            right: 32px;
            cursor: pointer;
            .icon {
                width: 24px;
                height: 24px;
            }
        }
        .title_iocn {
            width: 68px;
            height: 68px;
            border-radius: 8px;
            background-color: #ff5a00;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont {
                color: #fff;
                font-size: 26px;
            }
        }
        h1 {
            color: #2a2a2a;
            font-size: 24px;
            line-height: 28px;
            margin-top: 24px;
            font-weight: 400;
        }
        h2 {
            color: #727272;
            font-size: 14px;
            line-height: 28px;
            margin-top: 16px;
            font-weight: 400;
            padding: 0 27px;
            margin-bottom: 16px;
            span {
                color: #2a2a2a;
            }
        }
        .form_item {
            display: flex;
            align-items: center;
            span {
                text-align: left;
                font-size: 16px;
                color: #727272;
                white-space: nowrap;
                padding-left: 5px;
                padding-right: 10px;
            }
        }
        .checkbox {
            display: flex;
            justify-content: flex-start;
            padding: 15px 0;
        }
        .btn_box {
            display: flex;
            justify-content: space-between;
            button {
                width: 168px;
                height: 68px;
                border-radius: 8px;
                font-size: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                &:first-child {
                    background-color: var(--week-primary-color);
                    color: #fff;
                }
                &:last-child {
                    background-color: #f5f5f5;
                    color: #2a2a2a;
                }
                span {
                    font-size: inherit;
                }
            }
        }
    }
}
</style>
